// extracted by mini-css-extract-plugin
module.exports = {"item":"_5b8a","image":"c45c","title":"a8df","subTitle":"b52e","line":"_146c","text":"a566"};